//-- copyright
// GPE customization (gov.ao)
//
// Display field for the report_deadline column. Renders the deadline date as
// usual and, when the work package was reported after that deadline
// (reportedLate, derived server-side), appends a red "reported late" badge.
// Lateness is NOT stored.
//++

import { DateDisplayField } from 'core-app/shared/components/fields/display/field-types/date-display-field.module';
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { TimezoneService } from 'core-app/core/datetime/timezone.service';
import { I18nService } from 'core-app/core/i18n/i18n.service';

export class ReportDeadlineDisplayField extends DateDisplayField {
  @InjectField() override timezoneService:TimezoneService;

  @InjectField() I18n:I18nService;

  public override get canOverdue():boolean {
    return false;
  }

  public override render(element:HTMLElement, displayText:string):void {
    super.render(element, displayText);

    const reportedLate = (this.resource as unknown as { reportedLate?:boolean }).reportedLate;
    if (!reportedLate) {
      return;
    }

    const badge = document.createElement('span');
    badge.classList.add('op-report-deadline--late');
    badge.textContent = ` ${this.I18n.t('js.work_packages.report_deadline.late_badge', {
      defaultValue: 'Reported late',
    })}`;
    badge.title = this.I18n.t('js.work_packages.report_deadline.late_tooltip', {
      defaultValue: 'Reported after the report deadline',
    });
    element.appendChild(badge);
  }
}
